export const vi = {
  common: {
    loadError: 'Không tải được dữ liệu',
    retry: 'Thử lại',
    search: 'Tìm theo số, tiêu đề…',
    columns: 'Cột',
    export: 'Xuất CSV',
    cancel: 'Huỷ',
    save: 'Lưu',
    saved: 'Đã lưu',
    back: 'Quay lại',
    none: '—',
  },
  status: {
    draft: 'Nháp',
    pending: 'Chờ duyệt',
    returned: 'Trả lại sửa',
    approved: 'Đã duyệt',
    rejected: 'Từ chối',
    withdrawn: 'Đã rút',
  },
  stepStatus: {
    waiting: 'Chưa tới lượt',
    pending: 'Đang chờ',
    approved: 'Đã duyệt',
    rejected: 'Từ chối',
    returned: 'Trả lại',
    skipped: 'Bỏ qua',
    cancelled: 'Không cần',
  },
  skip: {
    requester: 'người đề xuất chính là người duyệt',
    same_approver: 'người này đã duyệt ở bước trước',
    top_of_organisation: 'không có cấp quản lý cao hơn',
  },
  source: {
    manager1: 'Quản lý trực tiếp',
    managerN: 'Quản lý cấp {{level}}',
    user: 'Người được chỉ định',
  },
  boxes: {
    mine: 'Đề xuất của tôi',
    inbox: 'Chờ tôi duyệt',
    all: 'Tất cả đề xuất',
    mineHint: 'Đề xuất bạn đã tạo và trạng thái duyệt.',
    inboxHint: 'Đề xuất đang chờ bạn (hoặc người uỷ quyền cho bạn) quyết định.',
    allHint: 'Mọi đề xuất bạn được xem theo vai trò.',
  },
  list: {
    new: 'Tạo đề xuất',
    number: 'Số',
    title: 'Tiêu đề',
    type: 'Loại',
    requester: 'Người đề xuất',
    status: 'Trạng thái',
    amount: 'Số tiền',
    waitingFor: 'Đang chờ',
    submittedAt: 'Ngày gửi',
    empty: 'Chưa có đề xuất nào',
    inboxEmpty: 'Không có đề xuất nào chờ bạn duyệt',
    allStatuses: 'Mọi trạng thái',
    loadMore: 'Xem thêm',
    delegations: 'Uỷ quyền duyệt',
  },
  form: {
    newTitle: 'Tạo đề xuất',
    editTitle: 'Sửa đề xuất',
    chooseType: 'Chọn loại đề xuất',
    noTypes: 'Chưa có loại đề xuất nào. Quản trị tạo loại đề xuất trong mục "Loại đề xuất".',
    title: 'Tiêu đề',
    titleHint: 'Ngắn gọn, ví dụ "Thanh toán tiền thuê studio tháng 11".',
    flow: 'Người duyệt',
    flowHint: 'Theo sơ đồ tổ chức và vai trò, cập nhật theo nội dung bạn nhập.',
    flowError: 'Chưa xác định được người duyệt',
    noApproval: 'Không cần duyệt: gửi xong chuyển thẳng kế toán chi.',
    submit: 'Gửi duyệt',
    saveDraft: 'Lưu nháp',
    submitted: 'Đã gửi đề xuất',
    draftSaved: 'Đã lưu nháp',
    from: 'Từ ngày',
    to: 'Đến ngày',
    upload: 'Tải file lên',
    uploading: 'Đang tải…',
    fileHint: 'PDF hoặc ảnh, tối đa 10 MB mỗi file.',
    select: 'Chọn…',
  },
  detail: {
    system: 'Hệ thống',
    requester: 'Người đề xuất',
    submittedAt: 'Gửi lúc',
    content: 'Nội dung',
    files: 'File đính kèm',
    flow: 'Luồng duyệt',
    round: 'Lần gửi {{round}}',
    onBehalfOf: 'thay {{name}}',
    timeline: 'Hoạt động',
    approve: 'Duyệt',
    reject: 'Từ chối',
    return: 'Trả lại sửa',
    withdraw: 'Rút đề xuất',
    edit: 'Sửa',
    editAndResend: 'Sửa và gửi lại',
    sendDraft: 'Gửi duyệt',
    decisionTitle: {
      approve: 'Duyệt đề xuất',
      reject: 'Từ chối đề xuất',
      return: 'Trả lại để sửa',
    },
    commentLabel: 'Ý kiến',
    commentRequired: 'Ghi rõ lý do để người đề xuất biết cần làm gì.',
    commentOptional: 'Không bắt buộc.',
    confirmWithdraw: 'Rút đề xuất này?',
    withdrawHint: 'Đề xuất dừng lại; bạn có thể tạo đề xuất mới.',
    commentPlaceholder: 'Viết bình luận…',
    send: 'Gửi',
    done: 'Đã cập nhật',
    events: {
      submitted: 'gửi đề xuất',
      resubmitted: 'sửa và gửi lại',
      approved: 'duyệt',
      rejected: 'từ chối',
      returned: 'trả lại để sửa',
      withdrawn: 'rút đề xuất',
      commented: 'bình luận',
      paid: 'ghi nhận đã chi',
      refunded: 'ghi nhận hoàn ứng',
      within_budget: 'trong dự toán mua sắm đã duyệt, chuyển thẳng kế toán',
      purchase_buying: 'nhận mua',
      purchase_delivered: 'giao hàng',
      purchase_cancelled: 'huỷ mua',
    },
  },
  delegations: {
    title: 'Uỷ quyền duyệt',
    description:
      'Trong thời gian vắng mặt, người được uỷ quyền duyệt thay bạn mọi đề xuất chờ bạn.',
    given: 'Bạn uỷ quyền',
    received: 'Người khác uỷ quyền cho bạn',
    delegate: 'Người duyệt thay',
    from: 'Từ ngày',
    to: 'Đến ngày',
    note: 'Ghi chú',
    add: 'Thêm uỷ quyền',
    remove: 'Huỷ uỷ quyền',
    none: 'Chưa có',
    searchPerson: 'Tìm người…',
  },
  types: {
    title: 'Loại đề xuất',
    description:
      'Biểu mẫu và luồng duyệt của từng loại. Đề xuất đã gửi giữ nguyên biểu mẫu lúc gửi.',
    new: 'Thêm loại đề xuất',
    name: 'Tên loại',
    fields: 'Trường',
    steps: 'Bước duyệt',
    active: 'Đang dùng',
    inactive: 'Đã đóng',
    empty: 'Chưa có loại đề xuất nào',
    editTitle: 'Sửa loại đề xuất',
    newTitle: 'Loại đề xuất mới',
    general: 'Thông tin chung',
    typeDescription: 'Mô tả',
    activeLabel: 'Cho phép tạo đề xuất loại này',
    form: 'Biểu mẫu',
    formHint: 'Các trường người đề xuất điền. Tiêu đề luôn có sẵn.',
    builtInForm:
      'Biểu mẫu của loại có sẵn này cố định (Portal dựa vào nó để tính toán). Bạn vẫn sửa được tên, luồng duyệt và người được xem.',
    addField: 'Thêm trường',
    fieldLabel: 'Tên trường',
    fieldKey: 'Mã',
    fieldType: 'Kiểu',
    required: 'Bắt buộc',
    options: 'Lựa chọn (mỗi dòng một lựa chọn)',
    help: 'Gợi ý',
    amountField: 'Trường số tiền chính',
    amountHint: 'Dùng cho điều kiện "số tiền" trong luồng duyệt và cột số tiền.',
    noAmount: 'Không có',
    flow: 'Luồng duyệt',
    flowHint: 'Duyệt lần lượt từ trên xuống. Bước có điều kiện chỉ áp dụng khi điều kiện đúng.',
    addStep: 'Thêm bước',
    stepKind: 'Người duyệt',
    kinds: { manager: 'Cấp quản lý', role: 'Vai trò', user: 'Người cụ thể' },
    level: 'Cấp',
    levels: { 1: 'Quản lý trực tiếp', 2: 'Quản lý cấp 2', 3: 'Quản lý cấp 3' },
    role: 'Vai trò',
    person: 'Người duyệt',
    condition: 'Điều kiện',
    always: 'Luôn áp dụng',
    when: 'Khi',
    ops: { gte: '≥', lt: '<', eq: '=', neq: '≠' },
    value: 'Giá trị',
    amount: 'Số tiền',
    viewers: 'Được xem mọi đề xuất loại này',
    viewersHint: 'Ngoài người đề xuất, người duyệt và trưởng đơn vị.',
    remove: 'Xoá',
    moveUp: 'Lên',
    moveDown: 'Xuống',
    saved: 'Đã lưu loại đề xuất',
    fieldTypes: {
      text: 'Chữ (một dòng)',
      textarea: 'Đoạn văn',
      number: 'Số',
      money: 'Số tiền (VND)',
      date: 'Ngày',
      date_range: 'Khoảng ngày',
      select: 'Danh sách chọn',
      file: 'File đính kèm',
      line_items: 'Danh sách khoản chi',
      purchase_items: 'Danh sách hàng cần mua',
    },
  },
  leave: {
    title: 'Nghỉ phép',
    description: 'Quỹ phép năm, các ngày nghỉ đã đăng ký và lịch nghỉ lễ của công ty.',
    mine: 'Của tôi',
    staff: 'Quỹ phép nhân viên',
    holidays: 'Ngày lễ',
    year: 'Năm',
    newLeave: 'Tạo đơn nghỉ',
    entitlement: 'Phép năm cả năm',
    accrued: 'Đã tích luỹ đến nay',
    carried: 'Phép năm trước chuyển sang',
    carriedUntil: 'dùng đến {{date}}',
    carriedExpired: 'Phép cũ hết hạn',
    adjustments: 'Điều chỉnh',
    taken: 'Đã nghỉ',
    booked: 'Đã đăng ký (chờ duyệt, sắp tới)',
    remaining: 'Còn lại cả năm',
    remainingShort: 'Còn lại',
    carriedShort: 'Chuyển sang',
    entitlementShort: 'Cả năm',
    bookedShort: 'Đã đăng ký',
    accrualHint: 'Mỗi tháng cộng {{days}} ngày; chỉ nghỉ được số ngày đã tích luỹ tới tháng nghỉ.',
    days: 'Ngày nghỉ trong năm',
    noDays: 'Chưa có ngày nghỉ nào',
    date: 'Ngày',
    amount: 'Số ngày',
    category: 'Loại',
    status: 'Trạng thái',
    categories: {
      annual: 'Phép năm',
      unpaid: 'Không lương',
      personal: 'Việc riêng có lương',
      social_insurance: 'Ốm / thai sản (BHXH)',
    },
    dayStatus: { pending: 'Chờ duyệt', approved: 'Đã duyệt' },
    employee: 'Nhân viên',
    unit: 'Đơn vị',
    hireDate: 'Ngày vào làm',
    adjust: 'Điều chỉnh',
    adjustTitle: 'Điều chỉnh quỹ phép',
    adjustHint:
      'Nhập số dương để cộng, số âm để trừ (bội số của 0,5). Ví dụ số dư đầu kỳ khi bắt đầu dùng Portal.',
    adjustDays: 'Số ngày',
    adjustReason: 'Lý do',
    adjusted: 'Đã điều chỉnh quỹ phép',
    holidayDate: 'Ngày',
    holidayName: 'Tên',
    holidayKind: 'Loại',
    kinds: { off: 'Nghỉ', workday: 'Làm bù (cuối tuần đi làm)' },
    addHoliday: 'Thêm ngày',
    noHolidays: 'Chưa có ngày lễ nào trong năm này',
    holidaysHint:
      'Ngày nghỉ lễ, nghỉ bù và các ngày cuối tuần đi làm bù theo thông báo của Nhà nước và công ty. Đơn nghỉ không tính các ngày nghỉ.',
    computed: 'Số ngày nghỉ',
    computedHint: 'Không tính thứ Bảy, Chủ nhật và ngày lễ.',
    afterThis: 'Phép năm còn lại sau đơn này',
    hire: 'Nhân viên chưa có hồ sơ nhân sự: số phép tính như làm đủ năm.',
  },
  purchaseItems: {
    name: 'Tên hàng',
    quantity: 'SL',
    unitPrice: 'Đơn giá dự kiến',
    amount: 'Thành tiền',
    note: 'Ghi chú, link tham khảo',
    add: 'Thêm mặt hàng',
    remove: 'Xoá mặt hàng',
    total: 'Dự toán',
  },
  purchase: {
    title: 'Mua sắm',
    description: 'Đề xuất mua sắm đã duyệt: nhận mua, giao hàng, đề nghị thanh toán.',
    tabs: { waiting: 'Chờ mua', buying: 'Đang mua', delivered: 'Đã giao', cancelled: 'Đã huỷ' },
    status: {
      waiting: 'Chờ hành chính mua',
      buying: 'Đang mua',
      delivered: 'Đã giao',
      cancelled: 'Đã huỷ',
    },
    card: 'Mua sắm',
    willBuy: 'Sau khi duyệt xong, hành chính sẽ mua.',
    request: 'Đề xuất',
    requester: 'Người đề xuất',
    items: 'Hàng hoá',
    estimate: 'Dự toán',
    neededBy: 'Cần trước',
    assignee: 'Người phụ trách',
    deliveredOn: 'Ngày giao',
    budgetLeft: 'Dự toán còn lại',
    payments: 'Đề nghị thanh toán',
    note: 'Ghi chú',
    take: 'Nhận mua',
    deliver: 'Đã giao',
    deliverHint: 'Người đề xuất sẽ nhận thông báo.',
    cancel: 'Huỷ mua',
    cancelHint: 'Ghi lý do; người đề xuất sẽ nhận thông báo.',
    reason: 'Lý do',
    pay: 'Đề nghị thanh toán',
    updated: 'Đã cập nhật mua sắm',
    empty: 'Không có đề xuất nào',
    andMore: '+{{count}} mặt hàng',
    forPurchase: 'Thanh toán cho mua sắm',
    withinBudget: 'Trong dự toán đã duyệt: không cần duyệt lại.',
    overBudget: 'Vượt dự toán còn lại: duyệt theo luồng thanh toán.',
    budgetHint:
      'Dự toán còn lại {{amount}}. Không vượt thì chuyển thẳng kế toán chi, vượt thì duyệt lại.',
    payTitle: 'Thanh toán: {{title}}',
  },
  lineItems: {
    description: 'Nội dung',
    amount: 'Số tiền',
    add: 'Thêm khoản',
    remove: 'Xoá khoản',
    total: 'Tổng cộng',
  },
  pay: {
    title: 'Chi tiền & tạm ứng',
    description: 'Đề nghị thanh toán và tạm ứng đã duyệt: chi tiền, theo dõi tạm ứng và hoàn ứng.',
    tabs: {
      awaiting: 'Chờ chi',
      paid: 'Đã chi',
      nothing: 'Trừ hết vào tạm ứng',
      open: 'Tạm ứng chưa hoàn',
      closed: 'Tạm ứng đã tất toán',
    },
    kinds: { payment: 'Thanh toán', advance: 'Tạm ứng' },
    methods: { cash: 'Tiền mặt', transfer: 'Chuyển khoản' },
    status: {
      awaiting: 'Chờ kế toán chi',
      paid: 'Đã chi',
      nothing: 'Không cần chi (trừ hết vào tạm ứng)',
    },
    request: 'Đề nghị',
    kind: 'Loại',
    requester: 'Người đề nghị',
    payee: 'Người nhận',
    total: 'Tổng tiền',
    settled: 'Trừ tạm ứng',
    due: 'Cần chi',
    paidAmount: 'Đã chi',
    paidOn: 'Ngày chi',
    method: 'Hình thức',
    paidBy: 'Người ghi',
    approvedAt: 'Ngày duyệt',
    amount: 'Số tạm ứng',
    remaining: 'Còn phải hoàn',
    dueOn: 'Hạn hoàn ứng',
    refunded: 'Đã nộp lại',
    closedAt: 'Ngày tất toán',
    empty: 'Không có mục nào',
    record: 'Ghi nhận đã chi',
    recordHint: 'Số tiền chi: {{amount}}. Người đề nghị sẽ nhận thông báo.',
    note: 'Ghi chú (số UNC, phiếu chi…)',
    vouchers: 'Chứng từ chi',
    recorded: 'Đã ghi nhận chi tiền',
    refund: 'Ghi nhận hoàn ứng',
    refundHint: 'Còn phải hoàn: {{amount}}.',
    refundAmount: 'Số tiền nhận lại',
    receivedOn: 'Ngày nhận',
    refundRecorded: 'Đã ghi nhận hoàn ứng',
    overdue: 'Quá hạn {{count}} ngày',
    card: 'Chi tiền',
    willPay: 'Sau khi duyệt xong, đề nghị chuyển sang kế toán để chi.',
    advanceCard: 'Khoản tạm ứng',
    settlements: 'Đã quyết toán bằng',
    refunds: 'Đã nộp lại',
    settles: 'Quyết toán tạm ứng',
    settlesRemaining: 'Tạm ứng còn {{amount}}',
    outstanding: 'Người đề nghị còn {{count}} khoản tạm ứng chưa hoàn, tổng {{amount}}.',
    outstandingOverdue: '{{count}} khoản đã quá hạn.',
    mine: 'Bạn còn {{count}} khoản tạm ứng chưa hoàn, tổng {{amount}}.',
    form: {
      settle: 'Quyết toán tạm ứng',
      settleHint: 'Nếu các khoản chi này dùng tiền đã tạm ứng, chọn khoản tạm ứng đó.',
      noSettle: 'Không quyết toán tạm ứng',
      total: 'Tổng các khoản chi',
      covered: 'Trừ vào tạm ứng',
      toPay: 'Kế toán chi thêm',
      toReturn: 'Bạn nộp lại',
      remaining: 'còn {{amount}}',
      due: 'hạn {{date}}',
    },
    widget: {
      none: 'Bạn không có khoản tạm ứng nào chưa hoàn',
      total: 'Còn phải hoàn',
      settle: 'Quyết toán',
    },
  },
  widget: {
    open: 'Mở danh sách',
    none: 'Không có đề xuất nào chờ bạn duyệt',
    more: 'và {{count}} đề xuất khác',
    leaveOpen: 'Chi tiết',
  },
  errors: {
    generic: 'Không thực hiện được. Thử lại sau.',
    'core.validation_failed': 'Thông tin chưa hợp lệ, kiểm tra các trường được đánh dấu.',
    'requests.no_manager':
      'Chưa xác định được quản lý của bạn trên sơ đồ tổ chức. Liên hệ quản trị để cập nhật.',
    'requests.no_role_holder': 'Chưa ai được giao vai trò duyệt của một bước. Liên hệ quản trị.',
    'requests.not_your_turn': 'Đề xuất này không còn chờ bạn duyệt.',
    'requests.not_withdrawable': 'Đề xuất đã có người duyệt, không rút được nữa.',
    'requests.not_editable': 'Chỉ sửa được bản nháp hoặc đề xuất bị trả lại.',
    'requests.type_inactive': 'Loại đề xuất này đã đóng.',
    'requests.duplicate_type': 'Đã có loại đề xuất trùng tên.',
    'requests.file_not_yours': 'Chỉ đính kèm được file do chính bạn tải lên.',
    'requests.leave_incomplete': 'Chọn loại nghỉ và thời gian nghỉ.',
    'requests.leave_empty': 'Khoảng thời gian này không có ngày làm việc nào.',
    'requests.leave_overlap': 'Đã có đơn nghỉ khác trong những ngày này.',
    'requests.leave_insufficient':
      'Không đủ phép năm đã tích luỹ. Tách phần vượt thành đơn nghỉ không lương.',
    'requests.self_delegation': 'Hãy chọn người khác.',
    'requests.not_payable': 'Đề nghị này không còn chờ chi.',
    'requests.refund_too_much': 'Số tiền vượt quá số còn phải hoàn.',
    'requests.purchase_closed': 'Đề xuất mua sắm đã giao hoặc đã huỷ.',
    'requests.delegation_past': 'Khoảng thời gian đã qua.',
    'core-files.too_large': 'File quá lớn (tối đa 10 MB).',
    'core-files.unsupported_type': 'Chỉ nhận PDF hoặc ảnh (JPG, PNG, WebP).',
  },
};

export const en: typeof vi = {
  common: {
    loadError: 'Could not load the data',
    retry: 'Retry',
    search: 'Search number, title…',
    columns: 'Columns',
    export: 'Export CSV',
    cancel: 'Cancel',
    save: 'Save',
    saved: 'Saved',
    back: 'Back',
    none: '—',
  },
  status: {
    draft: 'Draft',
    pending: 'Pending',
    returned: 'Returned',
    approved: 'Approved',
    rejected: 'Rejected',
    withdrawn: 'Withdrawn',
  },
  stepStatus: {
    waiting: 'Not yet',
    pending: 'Waiting',
    approved: 'Approved',
    rejected: 'Rejected',
    returned: 'Returned',
    skipped: 'Skipped',
    cancelled: 'Not needed',
  },
  skip: {
    requester: 'the requester is the approver',
    same_approver: 'this person approves in an earlier step',
    top_of_organisation: 'no higher manager',
  },
  source: {
    manager1: 'Direct manager',
    managerN: 'Manager level {{level}}',
    user: 'Named approver',
  },
  boxes: {
    mine: 'My requests',
    inbox: 'Awaiting my approval',
    all: 'All requests',
    mineHint: 'Requests you created and where they stand.',
    inboxHint: 'Requests waiting for your decision (or for someone who delegated to you).',
    allHint: 'Every request your roles let you see.',
  },
  list: {
    new: 'New request',
    number: 'No.',
    title: 'Title',
    type: 'Type',
    requester: 'Requester',
    status: 'Status',
    amount: 'Amount',
    waitingFor: 'Waiting for',
    submittedAt: 'Sent',
    empty: 'No requests yet',
    inboxEmpty: 'Nothing waiting for your approval',
    allStatuses: 'All statuses',
    loadMore: 'Load more',
    delegations: 'Delegate approvals',
  },
  form: {
    newTitle: 'New request',
    editTitle: 'Edit request',
    chooseType: 'Choose a request type',
    noTypes: 'No request types yet. Administrators create them under "Request types".',
    title: 'Title',
    titleHint: 'Short, e.g. "Studio rent for November".',
    flow: 'Approvers',
    flowHint: 'From the organisation chart and roles; updated as you fill in the form.',
    flowError: 'Approvers could not be determined',
    noApproval: 'No approval needed: once sent, it goes straight to accounting.',
    submit: 'Send for approval',
    saveDraft: 'Save draft',
    submitted: 'Request sent',
    draftSaved: 'Draft saved',
    from: 'From',
    to: 'To',
    upload: 'Upload file',
    uploading: 'Uploading…',
    fileHint: 'PDF or image, up to 10 MB each.',
    select: 'Choose…',
  },
  detail: {
    system: 'System',
    requester: 'Requester',
    submittedAt: 'Sent',
    content: 'Content',
    files: 'Attachments',
    flow: 'Approval flow',
    round: 'Submission {{round}}',
    onBehalfOf: 'for {{name}}',
    timeline: 'Activity',
    approve: 'Approve',
    reject: 'Reject',
    return: 'Return for changes',
    withdraw: 'Withdraw',
    edit: 'Edit',
    editAndResend: 'Edit and resend',
    sendDraft: 'Send for approval',
    decisionTitle: {
      approve: 'Approve request',
      reject: 'Reject request',
      return: 'Return for changes',
    },
    commentLabel: 'Comment',
    commentRequired: 'Say why, so the requester knows what to do.',
    commentOptional: 'Optional.',
    confirmWithdraw: 'Withdraw this request?',
    withdrawHint: 'The request stops; you can create a new one.',
    commentPlaceholder: 'Write a comment…',
    send: 'Send',
    done: 'Updated',
    events: {
      submitted: 'sent the request',
      resubmitted: 'edited and resent',
      approved: 'approved',
      rejected: 'rejected',
      returned: 'returned it for changes',
      withdrawn: 'withdrew the request',
      commented: 'commented',
      paid: 'recorded the payment',
      refunded: 'recorded a refund',
      within_budget: 'within the approved purchase estimate, sent to accounting',
      purchase_buying: 'took the purchase',
      purchase_delivered: 'delivered',
      purchase_cancelled: 'cancelled the purchase',
    },
  },
  delegations: {
    title: 'Delegate approvals',
    description: 'While you are away, your delegate decides every request waiting for you.',
    given: 'You delegate to',
    received: 'Delegated to you',
    delegate: 'Delegate',
    from: 'From',
    to: 'To',
    note: 'Note',
    add: 'Add delegation',
    remove: 'Cancel delegation',
    none: 'None',
    searchPerson: 'Search people…',
  },
  types: {
    title: 'Request types',
    description:
      'Form and approval flow of each type. Sent requests keep the form they were sent with.',
    new: 'New request type',
    name: 'Name',
    fields: 'Fields',
    steps: 'Steps',
    active: 'Open',
    inactive: 'Closed',
    empty: 'No request types yet',
    editTitle: 'Edit request type',
    newTitle: 'New request type',
    general: 'General',
    typeDescription: 'Description',
    activeLabel: 'Allow new requests of this type',
    form: 'Form',
    formHint: 'Fields the requester fills in. A title is always there.',
    builtInForm:
      'This built-in type has a fixed form (the Portal computes with it). Name, flow and viewers can still be changed.',
    addField: 'Add field',
    fieldLabel: 'Label',
    fieldKey: 'Key',
    fieldType: 'Type',
    required: 'Required',
    options: 'Choices (one per line)',
    help: 'Hint',
    amountField: 'Main amount field',
    amountHint: 'Used by "amount" conditions in the flow and the amount column.',
    noAmount: 'None',
    flow: 'Approval flow',
    flowHint: 'Steps run top to bottom. A step with a condition applies only when it holds.',
    addStep: 'Add step',
    stepKind: 'Approver',
    kinds: { manager: 'Manager', role: 'Role', user: 'Named person' },
    level: 'Level',
    levels: { 1: 'Direct manager', 2: 'Manager level 2', 3: 'Manager level 3' },
    role: 'Role',
    person: 'Approver',
    condition: 'Condition',
    always: 'Always',
    when: 'When',
    ops: { gte: '≥', lt: '<', eq: '=', neq: '≠' },
    value: 'Value',
    amount: 'Amount',
    viewers: 'May see every request of this type',
    viewersHint: 'Besides the requester, the approvers and unit heads.',
    remove: 'Remove',
    moveUp: 'Up',
    moveDown: 'Down',
    saved: 'Request type saved',
    fieldTypes: {
      text: 'Text (one line)',
      textarea: 'Paragraph',
      number: 'Number',
      money: 'Amount (VND)',
      date: 'Date',
      date_range: 'Date range',
      select: 'Choice list',
      file: 'Attachment',
      line_items: 'Expense lines',
      purchase_items: 'Items to buy',
    },
  },
  leave: {
    title: 'Leave',
    description: 'Annual leave balance, booked leave and the company holiday calendar.',
    mine: 'Mine',
    staff: 'Staff balances',
    holidays: 'Holidays',
    year: 'Year',
    newLeave: 'New leave request',
    entitlement: 'Annual leave this year',
    accrued: 'Credited so far',
    carried: 'Carried over',
    carriedUntil: 'usable until {{date}}',
    carriedExpired: 'Carry-over expired',
    adjustments: 'Adjustments',
    taken: 'Taken',
    booked: 'Booked (pending, upcoming)',
    remaining: 'Left for the year',
    remainingShort: 'Left',
    carriedShort: 'Carried',
    entitlementShort: 'Year',
    bookedShort: 'Booked',
    accrualHint: '{{days}} days are credited each month; only credited days can be taken.',
    days: 'Leave days this year',
    noDays: 'No leave yet',
    date: 'Date',
    amount: 'Days',
    category: 'Kind',
    status: 'Status',
    categories: {
      annual: 'Annual',
      unpaid: 'Unpaid',
      personal: 'Paid personal',
      social_insurance: 'Sick / maternity (insurance)',
    },
    dayStatus: { pending: 'Pending', approved: 'Approved' },
    employee: 'Employee',
    unit: 'Unit',
    hireDate: 'Hired',
    adjust: 'Adjust',
    adjustTitle: 'Adjust the leave balance',
    adjustHint: 'Positive adds, negative removes (multiples of 0.5), e.g. the opening balance.',
    adjustDays: 'Days',
    adjustReason: 'Reason',
    adjusted: 'Leave balance adjusted',
    holidayDate: 'Date',
    holidayName: 'Name',
    holidayKind: 'Kind',
    kinds: { off: 'Day off', workday: 'Weekend workday' },
    addHoliday: 'Add day',
    noHolidays: 'No holidays this year',
    holidaysHint:
      'Public holidays, bridge days and weekend days worked instead. Leave does not count days off.',
    computed: 'Leave days',
    computedHint: 'Weekends and holidays are not counted.',
    afterThis: 'Annual leave left after this request',
    hire: 'No HR profile: counted as a full year.',
  },
  purchaseItems: {
    name: 'Item',
    quantity: 'Qty',
    unitPrice: 'Est. unit price',
    amount: 'Amount',
    note: 'Note, reference link',
    add: 'Add an item',
    remove: 'Remove the item',
    total: 'Estimate',
  },
  purchase: {
    title: 'Purchases',
    description: 'Approved purchase requests: take them, deliver, request payment.',
    tabs: { waiting: 'To buy', buying: 'Buying', delivered: 'Delivered', cancelled: 'Cancelled' },
    status: {
      waiting: 'Waiting for the office',
      buying: 'Buying',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    card: 'Purchase',
    willBuy: 'Once approved, the office buys it.',
    request: 'Request',
    requester: 'Requester',
    items: 'Items',
    estimate: 'Estimate',
    neededBy: 'Needed by',
    assignee: 'In charge',
    deliveredOn: 'Delivered on',
    budgetLeft: 'Estimate left',
    payments: 'Payment requests',
    note: 'Note',
    take: 'Take it',
    deliver: 'Delivered',
    deliverHint: 'The requester will be notified.',
    cancel: 'Cancel',
    cancelHint: 'Give the reason; the requester will be notified.',
    reason: 'Reason',
    pay: 'Request payment',
    updated: 'Purchase updated',
    empty: 'No requests',
    andMore: '+{{count}} items',
    forPurchase: 'Pays for purchase',
    withinBudget: 'Within the approved estimate: no new approval.',
    overBudget: 'Beyond the estimate left: approved along the payment flow.',
    budgetHint:
      '{{amount}} of the estimate left. Within it, accounting pays directly; beyond, it is approved again.',
    payTitle: 'Payment: {{title}}',
  },
  lineItems: {
    description: 'Description',
    amount: 'Amount',
    add: 'Add a line',
    remove: 'Remove the line',
    total: 'Total',
  },
  pay: {
    title: 'Payments & advances',
    description: 'Approved payment and advance requests: pay them, track advances and refunds.',
    tabs: {
      awaiting: 'To pay',
      paid: 'Paid',
      nothing: 'Covered by an advance',
      open: 'Open advances',
      closed: 'Settled advances',
    },
    kinds: { payment: 'Payment', advance: 'Advance' },
    methods: { cash: 'Cash', transfer: 'Bank transfer' },
    status: {
      awaiting: 'Waiting for accounting',
      paid: 'Paid',
      nothing: 'Nothing to pay (covered by the advance)',
    },
    request: 'Request',
    kind: 'Kind',
    requester: 'Requester',
    payee: 'Payee',
    total: 'Total',
    settled: 'From advance',
    due: 'To pay',
    paidAmount: 'Paid',
    paidOn: 'Paid on',
    method: 'Method',
    paidBy: 'Recorded by',
    approvedAt: 'Approved on',
    amount: 'Advance',
    remaining: 'Still owed',
    dueOn: 'Due',
    refunded: 'Returned',
    closedAt: 'Settled on',
    empty: 'Nothing here',
    record: 'Record payment',
    recordHint: 'Amount paid: {{amount}}. The requester will be notified.',
    note: 'Note (transfer ref., voucher…)',
    vouchers: 'Payment vouchers',
    recorded: 'Payment recorded',
    refund: 'Record refund',
    refundHint: 'Still owed: {{amount}}.',
    refundAmount: 'Amount received',
    receivedOn: 'Received on',
    refundRecorded: 'Refund recorded',
    overdue: '{{count}} days overdue',
    card: 'Payment',
    willPay: 'Once approved, accounting pays it.',
    advanceCard: 'Advance',
    settlements: 'Settled by',
    refunds: 'Returned',
    settles: 'Settles advance',
    settlesRemaining: 'Advance still holds {{amount}}',
    outstanding: 'The requester has {{count}} open advances, {{amount}} in total.',
    outstandingOverdue: '{{count}} overdue.',
    mine: 'You have {{count}} open advances, {{amount}} in total.',
    form: {
      settle: 'Settle an advance',
      settleHint: 'If this spending used money advanced to you, pick that advance.',
      noSettle: 'No advance',
      total: 'Total spending',
      covered: 'Covered by the advance',
      toPay: 'Accounting pays',
      toReturn: 'You return',
      remaining: '{{amount}} left',
      due: 'due {{date}}',
    },
    widget: {
      none: 'You have no open advance',
      total: 'Still owed',
      settle: 'Settle',
    },
  },
  widget: {
    open: 'Open list',
    none: 'Nothing waiting for your approval',
    more: 'and {{count}} more',
    leaveOpen: 'Details',
  },
  errors: {
    generic: 'Could not complete. Try again later.',
    'core.validation_failed': 'Some information is invalid; check the highlighted fields.',
    'requests.no_manager':
      'Your manager is not set in the organisation chart. Ask an administrator to update it.',
    'requests.no_role_holder': 'Nobody holds the approval role of a step. Ask an administrator.',
    'requests.not_your_turn': 'This request is no longer waiting for you.',
    'requests.not_withdrawable': 'Someone already approved it; it cannot be withdrawn.',
    'requests.not_editable': 'Only drafts and returned requests can be edited.',
    'requests.type_inactive': 'This request type is closed.',
    'requests.duplicate_type': 'A request type with this name exists.',
    'requests.file_not_yours': 'Attach only files you uploaded yourself.',
    'requests.leave_incomplete': 'Choose the kind and the period.',
    'requests.leave_empty': 'No working day in this period.',
    'requests.leave_overlap': 'Another leave request covers these days.',
    'requests.leave_insufficient':
      'Not enough annual leave credited. Request the rest as unpaid leave.',
    'requests.self_delegation': 'Choose someone else.',
    'requests.not_payable': 'This request is no longer waiting for payment.',
    'requests.refund_too_much': 'More than what is still owed.',
    'requests.purchase_closed': 'This purchase is already delivered or cancelled.',
    'requests.delegation_past': 'That period is over.',
    'core-files.too_large': 'File too large (10 MB max).',
    'core-files.unsupported_type': 'Only PDF or images (JPG, PNG, WebP).',
  },
};
